module.exports = __webpack_public_path__ + "img/17.58768b16.jpg";